// extracted by mini-css-extract-plugin
export default {"setting_profile_page":"style_setting_profile_page__oSFqb"};